export default "__VITE_ASSET__1PFVtgfT__"